import { AvatarGroup, Stack, type StackProps, styled } from "@mui/material";
import type { FC } from "react";

const PREFIX = "RefusedCandidatesTableRow";

export const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  cell: `${PREFIX}-cell`,
  candidate: `${PREFIX}-candidate`,
  prescription: `${PREFIX}-prescription`,
  author: `${PREFIX}-author`,
  date: `${PREFIX}-date`,
  cause: `${PREFIX}-cause`,
  document: `${PREFIX}-document`,
  avatarGroup: `${PREFIX}-avatarGroup`,
};

interface IRefusedCandidatesTableRowProps extends StackProps {
  hasVisualizeCandidatePermission?: boolean;
  isAuthorizedArchive?: boolean;
}

export const RefusedCandidatesTableRow = styled<FC<IRefusedCandidatesTableRowProps>>(Stack, {
  shouldForwardProp: (prop) => prop !== "hasVisualizeCandidatePermission",
})(({ theme, hasVisualizeCandidatePermission, isAuthorizedArchive }) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    ...(!isAuthorizedArchive
      ? { paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) }
      : { paddingTop: theme.spacing(1), paddingBottom: theme.spacing(1) }),
    [`&.${classes.header}`]: {
      paddingTop: 0,
      paddingBottom: !isAuthorizedArchive ? theme.spacing(1) : theme.spacing(0),
    },
    [`&:not(.${classes.header}):hover`]: {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      boxShadow: "-4px 0 0 0 rgba(0, 0, 0, 0.04), 4px 0 0 0 rgba(0, 0, 0, 0.04)",
    },
    [`& .${classes.cell}`]: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      marginLeft: theme.spacing(1),
    },
    [`& .${classes.candidate}`]: {
      flex: "0 0 20%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      cursor: hasVisualizeCandidatePermission ? "pointer" : "unset",
    },
    [`& .${classes.prescription}`]: {
      flex: "0 0 15%",
    },
    [`& .${classes.date}`]: {
      flex: "0 0 15%",
      overflow: "hidden",
    },
    [`& .${classes.cause}`]: {
      flex: "0 0 25%",
      overflow: "hidden",
    },
    [`& .${classes.author}`]: {
      flex: "0 0 15%",
      overflow: "hidden",
    },
    [`& .${classes.document}`]: {
      textDecoration: "underline",
      overflow: "hidden",
      textOverflow: "ellipsis",
      cursor: "pointer",
    },
  },
}));

export const UserChipStyled = styled(AvatarGroup)(({ theme }) => ({
  [`&.${classes.avatarGroup}`]: {
    gap: theme.spacing(1),
    justifyContent: "start",
    "& .MuiAvatarGroup-avatar": {
      ...theme.typography.body1,
      backgroundColor: theme.palette.primary.main,
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: 0,
      border: 0,
    },
  },
}));
